function productVariantSelector() {
  const VariantSelectorSection = document.getElementById("scrollVariantSelector");
  const variantScrollSelectorButtons = document.querySelector(".scroll_variant_selector__buttons");

  const variantCards = document.querySelectorAll('.variant_card_visible');
  const variantCard = document.querySelector('.variant_card_selected');

  const selectorScrollButtons = document.querySelector('.scroll_variant_selector__buttons');
  const selectorScrollLeftButton = document.getElementById("variantSelectorscrollLeft");
  const selectorScrollRightButton = document.getElementById("variantSelectorscrollRight");

  function updateButtonState() {
    if (VariantSelectorSection.scrollLeft === 0) {
      selectorScrollLeftButton.classList.add('button-disabled');
    } else {
      selectorScrollLeftButton.classList.remove('button-disabled');
    }

    if (VariantSelectorSection.scrollLeft + VariantSelectorSection.clientWidth >= VariantSelectorSection.scrollWidth) {
      selectorScrollRightButton.classList.add('button-disabled');
    } else {
      selectorScrollRightButton.classList.remove('button-disabled');
    }
  }

  if (VariantSelectorSection) {
    selectorScrollLeftButton.addEventListener("click", function () {
      VariantSelectorSection.scrollLeft -= 150;
      updateButtonState();
    });
  
    selectorScrollRightButton.addEventListener("click", function () {
      VariantSelectorSection.scrollLeft += 150;
      updateButtonState();
    });

    // Initial check to disable buttons if necessary
    updateButtonState();

    // Update button states on scroll
    VariantSelectorSection.addEventListener('scroll', updateButtonState);
  }
}
productVariantSelector();